'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { Domains } from 'monitoring/constants/domains'
import { useLog } from 'monitoring/sendLog/client/useLog'
import type { OrderLineWithFormattedPrices } from 'my-purchases/types/purchaseCommon'
import { useProductInfo } from 'product/services/productInfo/client'
import { useMemo } from 'react'

import { normalizeData, normalizeDefaultArticle } from './normalization'

export const useArticle = ({
	articleItem,
}: {
	articleItem: OrderLineWithFormattedPrices
}) => {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()
	const { sendLog } = useLog()

	const { id } = articleItem

	const { data } = useProductInfo({
		productId: id,
		country: countryISO,
		language: languageISO,
	})

	const articleParsed = useMemo(() => {
		try {
			if (data) {
				return normalizeData({ product: data, articleItem })
			}

			return normalizeDefaultArticle({ articleItem })
		} catch (error) {
			sendLog({
				domain: Domains.MyPurchases,
				message: `An error occurred while parsing product info: ${error}`,
			})
			return null
		}
	}, [data, articleItem])

	return { article: articleParsed }
}
